import axios from 'axios';
import{getReqUrl,getLang,UrlDecode,getValue,setValue} from "@/utils/pub"
import VueCookies from 'vue-cookies'
axios.defaults.timeout = 5000;
axios.defaults.baseURL =getReqUrl()+'/';
let AUTH_TOKEN=(function(){
  return getValue("token");
})();
let USERID=(function(){
  return getValue("userid");
})();

let staffid=(function(){
  return getValue("staffid");
})();
let role=(function(){
  return getValue("role");
})();
//http request 拦截器
axios.interceptors.request.use(
  config => {



    if (process.env.NODE_ENV === 'development') {
      config.headers = {
        'Content-Type':'application/x-www-form-urlencoded'
      }
    } else if (process.env.NODE_ENV === 'production') {
      config.headers = {
        'Content-Type':'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin':'*',
        "Access-Control-Allow-Headers" : "Origin,Authorization,Origin, X-Requested-With, Content-Type, Accept,common"
      }
    }

      config.params = {'userid':getValue("userid"),'staffid':getValue("staffid"),'role':getValue("role"),'apiversion':2.1}

    let token = getValue("token")
  //let csrf = store.getters.csrf
  if (token) {


   if (process.env.NODE_ENV === 'development') {
    console.log('当前是开发环境');
    config.headers = {
      'Authorization': token,
      'Content-Type': 'application/x-www-form-urlencoded'

     }
  } else if (process.env.NODE_ENV === 'production') {
    console.log('当前是生产环境');
    config.headers = {
      'Authorization': token,
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin':'*',
      "Access-Control-Allow-Headers" : "Origin,Authorization,Origin, X-Requested-With, Content-Type, Accept,common"
     }
  }

  }

    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if(response.data.errCode ==2){
      router.push({
        path:"/login",
        querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
  axios.defaults.headers.common['Authorization'] = getValue('token');

  if (process.env.NODE_ENV === 'development') {
    console.log('当前是开发环境');
  } else if (process.env.NODE_ENV === 'production') {
    console.log('当前是生产环境');
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin,Authorization,Origin, X-Requested-With, Content-Type, Accept,common';
  }

   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

// api.request(url, data, (res)=> {
//   /*
//       查询之后格式this.filters.column.create_start_date中日期发生变化;
//       Wed Aug 09 2017 00:00:00 GMT+0800 (中国标准时间) 变成了 "2017-08-08T16:00:00.000Z";
//       所以使用 moment 日期格式化插件将时间转换成 [ Wed Aug 09 2017 00:00:00 GMT+0800 (中国标准时间) ] 格
//       式;
//   */

//   /*moment 安装 npm install moment --save*/

//  if(this.filters.column.create_start_date){
//      this.filters.column.create_start_date =
//       moment(this.filters.column.create_start_date);
//   }
//   if(this.filters.column.create_end_date){
//        this.filters.column.create_end_date =
//    moment(this.filters.column.create_end_date);
//   }
// })



// WEBPACK FOOTER //
// ./src/api/http.js